module.exports = __webpack_public_path__ + "static/img/icon_game_5.ecde6c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_game_5.png
// module id = +nC+
// module chunks = 0